import React from 'react';
import { Grid } from '@material-ui/core';

import { useStyles } from './TabPanel.styles';

interface TabPanelProps {
  value: number;
  index: number;
}

export const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, ...other }) => {
  const styles = useStyles();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      className={styles.panel}
      {...other}
    >
      {value === index && <Grid container>{children}</Grid>}
    </div>
  );
};
